import type { Row } from '@tanstack/react-table'
import { flexRender } from '@tanstack/react-table'
import type { VirtualItem } from '@tanstack/react-virtual'

import type { MassMessage } from '@/modules/chatting/types'

interface Props {
  virtualRow: VirtualItem
  row: Row<MassMessage>
  measureElement: (node: HTMLElement | null) => void
}

export const VirtualRow = ({ virtualRow, row, measureElement }: Props) => {
  return (
    <tr
      data-index={virtualRow.index}
      ref={(node) => measureElement(node)}
      key={row.id}
      className="absolute flex w-full border-b py-2"
      style={{ transform: `translateY(${virtualRow.start}px)` }}
    >
      {row.getVisibleCells().map((cell) => (
        <td
          key={cell.id}
          className="flex overflow-hidden text-ellipsis whitespace-nowrap p-2 text-sm font-medium leading-6"
          style={{
            width: cell.column.getSize(),
          }}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  )
}
